var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-link",
    "data-name": "Icon awesome-link",
    d: "M12.12,6.88a5.638,5.638,0,0,1,.013,7.963l-.013.014L9.627,17.351A5.641,5.641,0,0,1,1.65,9.373L3.027,8a.593.593,0,0,1,1.013.394,6.838,6.838,0,0,0,.36,1.956.6.6,0,0,1-.14.616l-.486.486a2.672,2.672,0,1,0,3.754,3.8l2.494-2.493a2.671,2.671,0,0,0,0-3.779,2.78,2.78,0,0,0-.384-.318.6.6,0,0,1-.258-.468,1.478,1.478,0,0,1,.434-1.106l.781-.781a.6.6,0,0,1,.764-.064,5.659,5.659,0,0,1,.762.638Zm5.23-5.23a5.647,5.647,0,0,0-7.977,0L6.88,4.143l-.013.014a5.642,5.642,0,0,0,.775,8.6.6.6,0,0,0,.764-.064l.781-.781a1.478,1.478,0,0,0,.434-1.106.6.6,0,0,0-.258-.468,2.78,2.78,0,0,1-.384-.318,2.671,2.671,0,0,1,0-3.779l2.494-2.493a2.672,2.672,0,1,1,3.754,3.8l-.486.486a.6.6,0,0,0-.14.616,6.838,6.838,0,0,1,.36,1.956A.593.593,0,0,0,15.973,11L17.35,9.626a5.647,5.647,0,0,0,0-7.977Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLink);
export default __webpack_public_path__ + "static/media/webLink.9933e7223d72966e7182a7fc35ec5582.svg";
export { ForwardRef as ReactComponent };